<template>
<div id="dlog" class="modal z-depth-modified--1" :class="modalStyle" ref="dlog"  v-if="active"> 
    <div 
      class="modal-content"
      :class="hasImage ?'featured-image' : ''">
      <div class="image-container">
        <div class="featured-image" :style="{backgroundImage: `url(${hasImage})`}" ></div>
      </div>
      <div class="modal-title">
        <slot name="title"></slot>
      </div>
      <slot>

      </slot>
      <div v-if="dataType === 'product_quantity'" class="row no-margin">
        
        <div class="col s12 price center clear">
          {{(product_object && product_object.product_price ? product_object.product_price : 0 ) *  qtyValue | currency}}
        </div>
       <div class="col s2 no-padding">
        <button @click="$_updateQtyAction('remove')" class="btn-floating btn-small white waves-effect"><i class="material-icons grey-text text-darken-3">remove</i></button>
       </div>
        <div class="col s8 center">
          <input type="number" ref="tv" style="width:75px; border: 1px solid rgba(0,0,0,.2); border-radius: 4px; text-align:center;" @input="$_updateQty($event)" value="1">
        </div>
        <div class="col s2 no-padding right-align">
          <button @click="$_updateQtyAction('add')" class="btn-floating btn-small waves-effect"><i class="material-icons white-text">add</i></button>
        </div>
      </div>
    </div>
    <div class="modal-footer" >
      <button 
        v-for="button in buttons" 
        v-bind:key="button.id" 
        @click="button.action"
        :disabled="button.isDisabled ? button.isDisabled : false"
        v-bind:class="[{'modal-close':button.close}, 'actions btn-flat z-depth-0 waves-effect close-modal']"  v-html="button.value">
      </button>
    </div>
</div>
</template>

<script>
import {mapState} from 'vuex'
import M from 'materialize-css'
export default {
  name: 'dialogComponent',
  props: {
    hasImage: {
      type: [String, Boolean],
      default: false
    },
    dataType: {
      type: String,
      default:''
    },
    modalStyle:{
      tpye:[String, Boolean]
    },
    qty_action:{
      type: [Function, Boolean]
    },
    product_object: {
      type: [Object, Array]
    },
    buttons: {
      type: [Object, Array]
    },
    domProps:{
      type: [Object, Array, Boolean]
    }
  },
  data () {
    return{
      btns:[],
      qtyValue: 1,
      dialogOptions:{
        dismissible: false,
        opacity:.3,
        onCloseStart:()=>{
          this.modalInstance.destroy()
          this.active = false
          this.modalInstance = null
        },
        onOpenEnd:()=>{
          
        },
        preventScrolling:false,
        startingTop:'60%',
        endingTop:'50%',
      },
      modalInstance: null,
      active:true,
    }
},
/* beforeDestroy (){
  this.modalInstance.destroy()
}, */
mounted(){
   setTimeout(() => {
        this.$_initModal()
   },100);
},
watch:{
  '$router.name':function(nV) {
    console.log(nV)
  }
},
methods:{
  $_updateQtyAction(e ) {
    //console.log(parseInt( ))
    let newNumber = e === 'add' ? this.qtyValue + 1 : this.qtyValue - 1
    let n = {target: {value:parseInt(newNumber)}}
    this.$_updateQty(n)
    this.$refs.tv.value = n.target.value
   /*  e === 'add' ? this.$_updateQty({target: parseInt(this.qtyValue) + 1})
                :  */
  },
  $_updateQty (a) {
    this.qtyValue = parseInt(a.target.value)
    this.qty_action(a.target.value)
    //this.$emit('test', parseInt(a.target.value))
    //this.$store.commmit('TEMP_PRODUCT_QTY', parseInt(a.target.value) )
  },
  $_initModal(){
    this.modalInstance = M.Modal.init(this.$refs.dlog, this.dialogOptions)
    this.modalInstance.open()
    }
  }
}
</script>
<style scoped lang="scss">
#dlog {
  border-radius: 5px;
    max-width: 350px;
    width: 95%;
    transform: translateY(-50%) !important;
    .modal-title {
      font-size: 20px;
      line-height: 1.2;
      text-transform: capitalize;
      margin-bottom: 8px;
      }
    p {
      margin: 6px 0px;
    }
}

.btn-floating {
  margin-top: 4px;
}
.modal {
  .modal-content  {
    padding: 24px 24px 12px 24px;
    .message {
      font-size: 16px;
      line-height: 1.2;
      color: #646464;
    }
    /* &.featured-image {} */
  }
}
</style>
